import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { RealResultsSection } from './components/RealResultsSection';
import { PainSection } from './components/PainSection';
import { AgitationSection } from './components/AgitationSection';
import { SolutionSection } from './components/SolutionSection';
import { TransformationSection } from './components/TransformationSection';
import { IncludesSection } from './components/IncludesSection';
import { ForWhoSection } from './components/ForWhoSection';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { EmotionalCloseSection } from './components/EmotionalCloseSection';
import { FinalCTASection } from './components/FinalCTASection';
import { SocialProofPopup } from './components/SocialProofPopup';
import { IncomeCalculator } from './components/IncomeCalculator';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <RealResultsSection data-id="element-3" />
      <IncomeCalculator data-id="element-4" />
      <PainSection data-id="element-5" />
      <AgitationSection data-id="element-6" />
      <SolutionSection data-id="element-7" />
      <TransformationSection data-id="element-8" />
      <IncludesSection data-id="element-9" />
      <ForWhoSection data-id="element-10" />
      <BeforeAfterSection data-id="element-11" />
      <BonusesSection data-id="element-12" />
      <PricingSection data-id="element-13" />
      <TestimonialsSection data-id="element-14" />
      <EmotionalCloseSection data-id="element-15" />
      <FinalCTASection data-id="element-16" />
      <SocialProofPopup data-id="element-17" />
    </div>;
}